import React, { useEffect, useState, useRef } from "react";
import "./Center.css";
// import "../NavBar/NavBar.css";

import Video from "../../Images/video-small.png";
import Camera from "../../Images/camera-small.png";

import Documents from "../../Images/Documents.png";

import Sundanse from "../../Images/Sundanse.png";
import POC4 from "../../Images/Sundanse.png";
// import POC4 from "./Images/POC4ver2.png";
import ENOTTA from "../../Images/ENOTTA 2.png";
import StartEngine from "../../Images/StartEngine.png";
import StartingBloch from "../../Images/StartingBloch.png";

//import UpdateUserPhotoURL from "../UserProfile/UpdateUserPhotoURL";
import photoRef from "../../Images/photoURL.png";
import {
  collection,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";

import { app } from "../lib/firebase";
import PostList from "./components/PostList";
import { createPost } from "./actions/index";
// import { NewGroupProfileType } from "../Types/groupProfile";
// import { NewUserProfileType } from "../Types/userProfile";
// import { NewProjectProfileType } from "../Types/projectProfile";
// import { NewProjectExperimentType } from "../Types/projectExperiment";

var bodyStyles = document.body.style;
bodyStyles.setProperty("--about-display", "none");
const photoURL = localStorage.getItem("myPicture");

//console.log("in left side and photoURL = ", photoURL);

//Now to get the userProfile from firebase so we can extract the profile picture
//we need to pass the userUID to a function and get the userProfile in return

//const photoRef = UpdateUserPhotoURL(photoURL);
//console.log("in center after UpdateUserPhotoURL and photoURL = ", photoRef);
const handleAboutClick = (event) => {
  console.log("Clicked!");
  bodyStyles.setProperty("--about-display", "none");
};

function Center() {
  // const [groupProfiles, setGroupProfiles] = useState<NewGroupProfileType[]>([]);
  // const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  // const [projectProfiles, setProjectProfiles] = useState<
  // 		NewProjectProfileType[]
  // 	>([]);
  // 	const [projectExperiments, setProjectExperiments] = useState<
  // 		NewProjectExperimentType[]
  // 	>([]);
  const [groupProfiles, setGroupProfiles] = useState([]);
  const [userProfiles, setUserProfiles] = useState([]);
  const [projectProfiles, setProjectProfiles] = useState([]);
  const [projectExperiments, setProjectExperiments] = useState([]);

  const [showCountries, setShowCountries] = useState("Show");

  const [openCountriesList, setOpenCountriesList] = useState("none");

  //let openCountriesList = "none";

  let numberOfCountries = 0;
  let numberOfGroups = 0;
  let numberOfProjects = 0;
  let numberOfUsers = 0;
  let numberOfExperiments = 0;

  let countries = [];
  const db = getFirestore(app);

  const [postContent, setPostContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null as File | null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const documentInputRef = useRef(null);

  function ShowClick() {
    console.log("ShowClick entered");
    if (showCountries === "Show") {
      setShowCountries("Close");
      setOpenCountriesList("block");
      //openCountriesList = "none";
    } else {
      setShowCountries("Show");
      setOpenCountriesList("none");
      //openCountriesList = "block";
    }
  }

  const q0 = query(collection(db, "Groups"));
  useEffect(
    () =>
      onSnapshot(q0, (snapshot) => {
        setGroupProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  //console.log("groupProfiles.length = ", groupProfiles.length);
  numberOfGroups = groupProfiles.length;

  const q1 = query(collection(db, "userProfiles"));
  useEffect(
    () =>
      onSnapshot(q1, (snapshot) => {
        setUserProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  numberOfUsers = userProfiles.length;

  for (let i = 0; i < numberOfUsers; i++) {
    if (userProfiles[i].userCountry !== undefined) {
      countries.push(userProfiles[i].userCountry);
    }
  }
  console.log("countries = ", countries);
  let unSortedArray = countries.reduce(function (a, b) {
    if (a.indexOf(b) < 0) a.push(b);
    return a;
  }, []);

  //let uniqueCountries = unSortedArray.sort((x, y) => x > y ? 1 : x < y ? -1 : 0)
  let uniqueCountries = unSortedArray.sort();

  //console.log("uniqueCountries = ", uniqueCountries);
  numberOfCountries = uniqueCountries.length;

  const q2 = query(collection(db, "projectProfiles"), orderBy("country"));
  useEffect(
    () =>
      onSnapshot(q2, (snapshot) => {
        setProjectProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  numberOfProjects = projectProfiles.length;

  const q3 = query(collection(db, "projectExperiments"));
  useEffect(
    () =>
      onSnapshot(q3, (snapshot) => {
        setProjectExperiments(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );
  numberOfExperiments = projectExperiments.length;

  const handleCreatePost = async () => {
    if (
      !postContent.trim() &&
      !selectedImage &&
      !selectedVideo &&
      !selectedDocument
    ) {
      return;
    }

    setIsSubmitting(true);
    try {
      // For now, we'll create the post without the image
      // TODO: Implement Firebase Storage upload for files
      const postData = {
        content: postContent,
        userId: "user1",
      };

      await createPost(postContent, "user1");

      // Clear form
      setPostContent("");
      setSelectedImage(null);
      setSelectedVideo(null);
      setSelectedDocument(null);
    } catch (error) {
      console.error("Error creating post:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleImageClick = () => {
    imageInputRef.current?.click();
  };

  const handleVideoClick = () => {
    videoInputRef.current?.click();
  };

  const handleDocumentClick = () => {
    documentInputRef.current?.click();
  };

  return (
    <>
      <nav>
        <div className="show">
          <p>
            footprints - about us <br />
            <br />
            We are the researchers who care... <br />
            We care about sharing our knowledge, <br />
            our experience, and our data to enable <br />
            others to discover new knowledge and <br />
            and leave their own footprints in the <br />
            sands of research.
          </p>
          <button className="closeButton" onClick={handleAboutClick}>
            {" "}
            Close
          </button>
        </div>
      </nav>
      <nav>
        <div style={{ marginTop: 30 }}>
          <div className="promote">
            <div>
              <h5 className="statistics" style={{ marginLeft: -3 }}>
                Countries
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfCountries}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Groups
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfGroups}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Projects
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfProjects}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Experiments
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfExperiments}
              />
              <h5 className="statistics" style={{ marginLeft: 15 }}>
                Users
              </h5>
              <input
                type="text"
                readOnly
                style={{ paddingLeft: 3, width: 40 }}
                value={numberOfUsers}
              />
            </div>
            <button
              style={{
                display: "inline-block",
                width: 60,
                height: 25,
                backgroundColor: "#1876f2",
                color: "white",
                borderRadius: 10,
                marginLeft: 0,
                cursor: "pointer",
              }}
              onClick={() => ShowClick()}
            >
              {showCountries}
            </button>
            <select
              name="Country List"
              id="country-list"
              style={{
                marginLeft: 70,
                marginTop: -20,
                width: 120,
                display: openCountriesList,
              }}
            >
              {uniqueCountries.map((uniqueCountries, key) => (
                <option key={key} value={uniqueCountries}>
                  {uniqueCountries}
                </option>
              ))}
            </select>
            <br />
            <h3> footprints announcement:</h3>
            <h5> Earn points towards conferences and publication fees by</h5>
            <div>
              <h5 style={{ display: "inline" }}>taking a</h5>
              <a
                style={{ display: "inline", marginLeft: 6, fontSize: 15 }}
                href="#"
              >
                <strong>survey,</strong>
              </a>
              <h5 style={{ display: "inline" }}> sharing data,</h5>
              <h5 style={{ display: "inline" }}>
                {" "}
                sharing knowledge scripts,{" "}
              </h5>
            </div>{" "}
            <h5> posting accademic blogs, and answering questions</h5>
            <br />
            <div>
              <div className="write-post-container">
                <div className="create-post">
                  <h4 className="post-share">Share something...</h4>
                  <div className="user-profile">
                    <img src={photoRef} alt="User profile" />
                    <textarea
                      rows={3}
                      placeholder="Share your thoughts here and add optional items from below..."
                      value={postContent}
                      onChange={(e) => setPostContent(e.target.value)}
                      disabled={isSubmitting}
                    ></textarea>
                  </div>

                  {/* Preview section for selected files */}
                  {selectedImage && (
                    <div style={{ marginTop: "10px", position: "relative" }}>
                      <img
                        src={URL.createObjectURL(selectedImage)}
                        alt="Selected"
                        style={{ maxHeight: "200px", borderRadius: "8px" }}
                      />
                      <button
                        onClick={() => setSelectedImage(null)}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          background: "rgba(0,0,0,0.5)",
                          border: "none",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}

                  <div className="post-input-container">
                    <div className="add-post-links">
                      {/* Hidden file inputs */}
                      <input
                        type="file"
                        ref={imageInputRef}
                        onChange={(e) =>
                          setSelectedImage(e.target.files?.[0] || null)
                        }
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      <input
                        type="file"
                        ref={videoInputRef}
                        onChange={(e) =>
                          setSelectedVideo(e.target.files?.[0] || null)
                        }
                        accept="video/*"
                        style={{ display: "none" }}
                      />
                      <input
                        type="file"
                        ref={documentInputRef}
                        onChange={(e) =>
                          setSelectedDocument(e.target.files?.[0] || null)
                        }
                        accept=".pdf,.doc,.docx"
                        style={{ display: "none" }}
                      />

                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleVideoClick();
                        }}
                      >
                        <img src={Video} alt="Video" /> Video
                        {selectedVideo && (
                          <span className="file-selected">✓</span>
                        )}
                      </a>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleImageClick();
                        }}
                      >
                        <img src={Camera} alt="Photos" /> Photos
                        {selectedImage && (
                          <span className="file-selected">✓</span>
                        )}
                      </a>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleDocumentClick();
                        }}
                      >
                        <img src={Documents} alt="Documents" /> Documents
                        {selectedDocument && (
                          <span className="file-selected">✓</span>
                        )}
                      </a>
                      <button
                        onClick={handleCreatePost}
                        disabled={
                          isSubmitting ||
                          (!postContent.trim() &&
                            !selectedImage &&
                            !selectedVideo &&
                            !selectedDocument)
                        }
                        style={{
                          padding: "8px 16px",
                          backgroundColor:
                            !postContent.trim() &&
                            !selectedImage &&
                            !selectedVideo &&
                            !selectedDocument
                              ? "#e5e7eb"
                              : "#3b82f6",
                          color: "white",
                          border: "none",
                          borderRadius: "20px",
                          cursor:
                            !postContent.trim() &&
                            !selectedImage &&
                            !selectedVideo &&
                            !selectedDocument
                              ? "not-allowed"
                              : "pointer",
                          marginLeft: "auto",
                          marginRight: "40px",
                          display: "block",
                          marginTop: "10px",
                        }}
                      >
                        {isSubmitting ? "Posting..." : "Post"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h3> footprints promotion:</h3>
              <h5 style={{ marginLeft: 20, marginTop: 20 }}>SUNDANSE</h5>
              <a href="https://sundanseproject.eu/" target="_blank">
                <img src={Sundanse} style={{ marginTop: 20, width: 600 }}></img>
              </a>
              <br></br>
              <h5 style={{ marginLeft: 20 }}>POC4TRIAGE</h5>
              <a href="https://poc4triage.eu/" target="_blank">
                <img src={POC4} style={{ height: 200, width: 600 }}></img>
              </a>
              <br></br>
              <h5 style={{ marginLeft: 20 }}>ENOTTA</h5>
              <a href="https://enotta.eu/" target="_blank">
                <img src={ENOTTA} style={{ height: 200, width: 600 }}></img>
              </a>
            </div>
            <br></br>
            <br></br>
            <div>
              <h3> footprints endorsements:</h3>
              <h5 style={{ marginLeft: 20, marginTop: 20 }}>StartEngine</h5>
              <a href="https://www.startengine.com/" target="_blank">
                <img
                  src={StartEngine}
                  style={{ marginTop: 5, width: 600 }}
                ></img>
              </a>
              <h5 style={{ marginLeft: 20, marginTop: 20 }}>Starting Bloch</h5>
              <a href="http://www.startingbloch.com/en/" target="_blank">
                <img
                  src={StartingBloch}
                  style={{ marginTop: 5, width: 600 }}
                ></img>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <PostList currentUserId="user1" />
    </>
  );
}

export default Center;
